module.exports = __webpack_public_path__ + "img/1.14a9e2d6.png";